module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")])]), _vm._v("rime-scene investigator Shanna Dawson paused on the threshold to gather her bearings. The dilapidated four-room house reeked of stale beer, cigarette smoke, greasy fast food and the rancid horror of death. As a CSI, she was more accustomed to the latter than the former.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The interior of the house, located a few blocks from Carlyle University, a private college outside of Chicago, was a pigsty; fast-food containers, smelly clothes, dirty dishes and empty beer cans were strewn everywhere. Talk about a CSI’s nightmare.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment she imagined the kids who lived there. The victim, Brady Wallace, was a young college student who shared the place with three other guys. Yet despite the mess, she imagined this was the type of place the so-called popular kids would gravitate to for parties. A college student’s version of fun and excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not hers, though. During her four years of college she’d never been invited to student gatherings. The party scene had never appealed to her. She was too serious, too introspective to indulge in lighthearted activities.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fun hadn’t been a part of her world in a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suppressing a sigh, she got to work. There was so much evidence to collect, she’d easily be here for hours. As she walked through the foyer and into the living room, she overheard two cops arguing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is a homicide investigation, Murphy. Campus police don’t have jurisdiction over homicides.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. But this incident occurred on my turf. Give me a break, Nelson. The victim is my brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Half brother,” the detective corrected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brother just the same.” The campus cop, Murphy, was stubborn. After a long moment where it seemed the homicide cop wasn’t going to give in, Murphy sighed and scrubbed a hand along his bristly jaw. “At least give me the courtesy of keeping me informed of the details of your investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Murphy snagged her attention, mostly because he was the victim’s half brother and because he didn’t look much like the local campus cops she was used to. And not just because of his tall, broad-shouldered good looks. His body appeared to be pure muscle, and he wore his wheat-blond hair military short. His face wasn’t handsome in the traditional sense but bore deeply worn grooves of experience, as if he’d carried the weight of the world on his shoulders. His green eyes held the shadows of a deep pain she could relate to. She was inexplicably drawn to him, as if he might be a kindred soul, but she forced herself to turn away, examining the crime scene.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("Brady Wallace’s body was lying on the floor, in the walkway between the living room and the kitchen. His bright red hair was matted with blood, the left side of his skull concave where it had been crushed. A heavy marble rugby trophy was lying on the floor beside him, ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("the four-by-four-inch base covered with hair and blood. She imagined microscopic evidence would confirm the blood and tissue matched the victim’s scalp.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The position of the body was distinctive. Why was he lying on the floor, in the walkway between the living room and kitchen? Had he run from his attacker? Or had he been on his way to the kitchen for something to eat when someone clubbed him from behind?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And who could hate a college student enough to kill him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brady was young, barely twenty. The callous waste of a young life always upset her. She’d grown up believing in God, but over the years had drifted away from the church and her faith. And at times like this, when she faced the hard edge of death, she really couldn’t understand God’s plan. What had this kid done to deserve death? She couldn’t imagine. Feeling slightly sick, she glanced back over at the two cops who’d fallen silent as they’d registered her presence. She forced a professional expression on her face as she faced their curious stares. “Who found the body?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One of his roommates, Kyle Ryker.” Murphy’s face was bleak as he scanned the room. “Four boys live here—the victim, Brady Wallace, and three others— Kyle Ryker, Dennis Green and Mark Pickard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They must have had a party last night,” she murmured with a wry sigh. Saturday nights were big party nights, so she shouldn’t be surprised. “I’d hate to think the place always looks like this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Murphy grimaced and lifted a shoulder. “It’s not much better on any other day. But you’re right—they did have a party, one that apparently lasted until the wee hours of the morning. According to Kyle, Brady was alive at four in the morning, when Kyle went up")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("stairs to crash for what was left of the night. When Kyle came down to get something to eat from the kitchen about nine-thirty, he tripped over Brady’s body.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Brady’s half brother, Murphy obviously had a personal stake in solving this crime. She felt a tug of sympathy. She knew better than anyone how difficult it was to deal with the violent aftermath of a crime that hit too close to home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Detective Hank Nelson.” The older cop, wearing the ill-fitting polyester suit coat, quickly introduced himself. “And this is University Campus Police Officer Quinn Murphy. I’ll be taking the lead on this homicide investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She understood the implied order and gave both men a brief nod. “Shanna Dawson, crime-scene investigator. My boss, Eric Turner, will be joining me shortly. If you gentlemen wouldn’t mind stepping outside, I’d like to get to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two cops exchanged a long look as if debating their right to stay, but in the end they both turned and headed for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Officer Murphy?” she called, before they could both disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned toward her, his eyebrow raised questioningly. “Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d like to talk to you later, if you have time.” She knew Detective Hank Nelson would do the full investigation into all aspects of Brady’s life, but she was curious to know more about Brady. Her methods might be somewhat unorthodox, but the more she understood the victim, the better job she’d do with her investigation. As the victim’s brother, Murphy would be a great source of information.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“Of course.” He came over to hand her his campus ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("police business card. “Call me when you’re finished processing things here.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will.” She pocketed the card and watched him leave. When she was alone, she picked up the camera around her neck and began to record the initial evidence of the crime scene.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn Murphy would mourn his half brother’s passing, but at least he had the comfort of knowing what happened. Maybe not the who or the why, but the rest. All some families knew was that a loved one had disappeared. They never knew if their loved one was dead or alive, at peace or living in some awful situation, praying for salvation and longing for home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shanna took a deep breath and let it out slowly, shaking off the painful memories of the past. She’d made it her mission over the years to bring families closure. To bring the comfort of knowledge. The peace of acceptance. Today she’d collect every possible clue, piece together as much of the puzzle as she could until she discovered who killed Brady Wallace and why. She’d do whatever was possible to help Brady’s family begin to heal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even though there were many wounds that never could.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s going to take us forever to dust for prints,” her boss pointed out in exasperation. “The kids had a party on Saturday night, and there were probably at least fifty people in and out of this place. How on earth are we going to isolate anything useful?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Eric was right—this was a long shot for sure. “The police are interviewing the roommates, trying to get a list of party attendees together. I believe this is personal, likely someone with a grudge against Brady.” ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("She glanced around the filthy room, imagining how the events might have played out. “I have a hunch this kid knew his attacker. To have this happen after a party doesn’t come across as premeditated, but more like a crime of opportunity, as if Brady was in the wrong place at the wrong time. Using the trophy to bash in his head could have been a simple act of rage or revenge. I’d like to start by dusting Brady’s bedroom and the living room for prints.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eric let out another sigh. “It just seems like a lot of effort for very little payoff. But you’re right, the logical place to start is the bedroom and crime scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded and went back to work. Her back ached from being hunched over for the past several hours, but she ignored the discomfort, concentrating on finding the proverbial needle in the haystack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she worked, her mind drifted to Quinn Murphy. Had he broken the distressing news of Brady’s death to the rest of his family? Considering Brady had a different last name than him, she assumed they shared a mother rather than a father. Did Brady have other siblings? Were they huddled close right now, drawing love and support from each other?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She dragged her mind from things that didn’t concern her, satisfied when she managed to find a few isolated prints on the rugby trophy, as well as other parts of the room. She did better up in Brady’s room, where there was less clutter. Her boss grimaced but helped her collect the beer cans to check for prints. By the time they were finished, they’d probably have more suspects than they’d know what to do with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Suspects that may or may not lead to the identity of the killer, since there was no guarantee Brady’s murderer had left prints at the scene. Still, they didn’t have ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("much else to work from. Hair fibers were as much of a nightmare as dusting for prints because of the number of people who’d been in the house, not to mention that Dennis Green’s cat shed like crazy in a house that had rarely if ever seen a vacuum.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Running all the fingerprints and hair fibers would take time, so she sent the strips and samples off to the lab for the techs to start working on, prioritizing the ones from the trophy and Brady’s room. At the very least, they’d discover if any of the partygoers had criminal records.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside, she paused at her car, glancing down at Quinn Murphy’s card, debating whether to talk to him now or to go home first to shower and change. She was hungry, having worked the crime scene for almost eight hours straight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Home first, she decided. Then she’d contact Quinn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled up to her house, pausing at the mailbox on her way into the driveway. Sometimes she became so lost in her active cases that she forgot to pick up her mail. Today was Sunday, but had she picked it up yesterday? She didn’t think so. When she opened the box, she found it was jammed full. As she pulled everything out, a small white envelope with her name printed on the outside, with no postage stamp or return address, made her heart pound heavily in her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another note. The third in the past two weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared at it for a long minute, wishing it was nothing more than a figment of her imagination. But of course it wasn’t. She headed inside the house. Even though she was tired and hungry, she used her own kit to dust for prints. She wasn’t surprised not to find any.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t found prints on the previous two notes, either.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trepidation burned as she opened the envelope flap. Slowly she withdrew the single piece of paper. The message was brief: “I’m coming for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Four little words. She dropped the card, struggling to breathe normally as fear clogged her throat. So far, each of the notes she’d received bore a different message.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Guilty as charged.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m watching you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m coming for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her knees went weak and she sank into a kitchen chair, struggling not to let fear overwhelm her. Who was doing this? And why? She wanted to think it was some person’s strange idea of a joke, but the sinister tone of the notes wasn’t easily shrugged off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which is exactly what the creep intended. He wanted to scare her. He wanted her to panic. Only a coward would send anonymous notes in the first place. And since she didn’t have any men in her life, hadn’t so much as had one significant long-term relationship, this had to be connected to her job.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d gone through all of her most recent cases, trying to figure out which one may have caused someone to fixate on her. The most likely case was one that had wrapped up two weeks ago, garnering her some media attention. Shanna usually preferred to work behind the scenes, but in this case, the investigation of a well-known cardiac surgeon’s murder had cast her reluctantly into the limelight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The trial had been difficult but her evidence had been solid, and in the end her testimony had caused the jury to find the surgeon’s ex-wife, Jessica Markoviack, guilty of murder. But Jessica couldn’t be the stalker, ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("since she was currently serving a life sentence in an all-female state prison.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A friend of Jessica’s, perhaps? If she remembered right, Jessica had a boyfriend, a guy named Clay Allen who hadn’t been involved in the murder, at least according to the evidence. But that didn’t mean he wasn’t capable of doing the deed. She needed to go back through her case notes, to refresh her memory of the guy’s background. He was a viable suspect, someone who had a reason to carry a grudge against her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fear gave way to anger as she rose to her feet. Maybe it was time to bring the police into this. The first two notes had been creepy but not outright threatening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m coming for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She ground her teeth and turned her back on the note. She’d call the police, even though she knew there was little they could do. Hadn’t she already tried to trace the origin of the white cards herself? There was nothing special about them, they were commonly stocked in every office supply store in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaving the white card smudged with dark fingerprint powder on the table, she headed down the hall to the bathroom. First she’d shower, and then scrounge around for something to eat. It was only seven-thirty, and she still wanted to interview Quinn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Focusing her attention on Brady’s death would help her to ignore the eerie feeling of someone watching her, no doubt already planning his next move.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn Murphy read through the extensive list of names of all the kids who’d attended Brady’s party. The letters blurred and he had to blink to focus.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("He rubbed his eyes, forcing himself to stay awake, ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("even though he’d been up for the past thirty-six hours straight. There were already forty-one names on the list, and he was certain there were more that had been forgotten. Kids who’d come only for a few minutes, or those who blended into the woodwork to the point no one ever remembered.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had the murderer stood back, watching? Waiting for the right moment to strike? He had no way of knowing. Wishing there was at least one solid lead to go on, he picked up the list again. Brady’s girlfriend’s name was glaringly absent. Anna Belfast had gotten hysterical when he’d told her about Brady’s death. No college student, even one in the theater program, could be that good of an actress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna won the lead role of Hannah in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seven Brides for Seven Brothers")]), _vm._v(" and had done a performance at the theater starting at seven o’clock the night of the party. She’d been irritated that Brady hadn’t come to see her and claimed she’d refused to go to his party afterward, choosing to attend a cast get-together after the show instead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her alibi was solid, confirmed by several other theater students. Although the suspicious part of his mind insisted there was likely time for her to come to Brady’s party after the cast get-together had broken up. Had Anna come to the party to find Brady with another girl? Her roommate, Maggie Carson, also had a role in the play and claimed Anna had come home right afterward, but there was a chance Maggie had lied to cover for Anna. Or Anna could have slipped out even later, after her roommate fell asleep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Sweet little Anna didn’t seem to be the type to bash Brady in the head, but her on-again, off-again relation")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("ship with his little brother was enough to keep her on the suspect list.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They didn’t have the official report confirming the time of death, but the coroner at the scene had estimated it to be somewhere between five and seven in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His phone rang, startling him out of his thoughts. He frowned. The number wasn’t one he recognized, but he answered it anyway. “Murphy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Officer Murphy, this is Shanna Dawson. I’m sorry to call you so late, but the crime scene took much longer than normal to process.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not surprised.” He could easily believe that going through the party mess had taken several long hours. He glanced at his watch and realized it wasn’t as late as it felt—just eight-thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you’re still available, I’d love to talk to you. But if you’d rather wait until tomorrow, I’d certainly understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pursed his lips, thinking fast. The polite thing to do would be to wait until morning. Shanna had to be as exhausted as he was. But he also knew he wouldn’t sleep, couldn’t rest until he’d done everything possible to find Brady’s killer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tonight is fine.” He didn’t want to let her off the hook, and there was always the chance she’d give him some details on what they’d found. “Where would you like to meet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a slight pause before she responded, “I’ll meet you at Karly’s Kitchen on Dublin Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sounds good. I can be there in twenty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("He actually made it in fifteen, but Shanna must live even closer because he found her already seated at a ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("booth, nursing a cup of coffee. He slid in across from her, glancing up as the waitress approached. “I’ll have some coffee, too, thanks.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shanna’s face was pale and drawn, as if she’d taken Brady’s death as personally as he had. With her wavy dark hair, alabaster skin and wide blue eyes, she reminded him more of a kindergarten teacher than a CSI. Maybe it was the air of innocence clinging to her. He’d thought most law-enforcement types became hardened by the brutal evidence of violence, but Shanna’s personality didn’t seem to have that distinctive hard edge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She summoned a smile. “How are you?” she surprised him by asking. “Is your family doing all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amazed that she cared enough to ask, he sat back in his seat. She couldn’t know he wasn’t really a part of the family, not in the way she’d meant. His mother had pretty much abandoned him when she’d divorced his father, but over the years he’d made an effort to mend the rift between them, especially once his father died. No matter what, though, he was still an outsider. His mother had found a new life with her second husband, James Wallace, and his half-siblings, Brady and Ivy, were the joys of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now Brady was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d given his mother the news, taking the brunt of her anger and frustration as she railed at him. Knowing that she would have preferred if he was the one who’d died instead of Brady was difficult to ignore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I—my mother is taking Brady’s death pretty hard, as you can imagine.” He tried to soften his gruff tone. He didn’t hold a grudge against Brady, even though the kid had been offered every opportunity possible to succeed in life. More than Quinn had been given, that’s for sure. But Brady was basically a good kid.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Quinn had gotten older, he’d understood how his very presence reminded his mother of her dismal marriage to his father. A fact that was indirectly his fault, since she’d only married his father because she’d gotten pregnant with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry for your loss.” Shanna surprised him again by reaching across the table to touch the back of his hand in a simple gesture meant to offer comfort. “I’ll do everything possible to find Brady’s murderer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know.” He was impressed by her staunch dedication. And her empathy. Shanna looked young, barely twenty, although he figured with her training and experience she must be at least in her mid-to-late twenties. She was beautiful, her long wavy hair framing a heart-shaped face. The flicker of awareness annoyed him; he was here to help solve Brady’s murder, nothing more. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She began the drill, asking about his half brother’s life, going over all of Brady’s friends and roommates. He gave her everything he knew, which wasn’t all that much, since Brady had resented having his older half brother as a campus cop. Brady had kept his distance from Quinn as much as possible. Especially after Quinn had been the one to bust one of Brady’s parties a month earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he’d known about this party last night, he would have busted it, too. And then maybe his brother would still be alive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just another reason to feel guilty. Although it wasn’t like he was sitting around doing nothing. He’d been investigating a potential sexual assault on a young female student instead.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He pulled his mind to the matter at hand. He told Shanna everything he knew, although it wasn’t any")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("thing different from what he’d told the detective. Still, working with Shanna as they reviewed the list of kids who’d attended the party made him feel as if he were part of the investigation instead of an innocent bystander.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At ten o’clock, she yawned so wide her jaw popped, and he realized he’d selfishly kept her up long enough. “It’s late—we’d better go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded, signaling the waitress to bring their bill. He knew she intended to pay, but he took the bill from the waitress anyway. “My treat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shanna frowned. “You don’t have to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please, I want to.” She couldn’t know how much he’d needed to talk to her tonight, to be involved at least this much in the investigation. Besides, he couldn’t get into the idea of allowing a woman to pay. Call it old-fashioned, but he didn’t care. He stood, waiting for her to precede him out of the diner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside, there were only a few other cars in the postage stamp-size parking lot. His SUV was on the far left end, but she turned toward the right, where a red Toyota Camry was parked next to a row of bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, Quinn,” she said, formally shaking his hand. “I’ll be in touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Her hand felt small and fragile in his and he released it reluctantly. He followed, intent on making sure she got safely into her car. She only took a few steps though, before suddenly stopping.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She whirled around, coming back toward him. She grabbed his arm in a tight grip. “Do you see him?” she asked in a low, urgent tone. “Do you see the man standing next to my car?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Man?” He peered over her shoulder, not seeing any sign of a person, male or otherwise. Had her exhausted ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("mind played tricks on her? “Relax, it’s okay. I don’t see anyone.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you saying I imagined him?” The sharp edge to her tone made him lift a curious brow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I believe you. But I don’t see him now. Maybe he disappeared behind those bushes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Abruptly, she let go of his arm, swinging back to stare at her car. “He’s gone. I can’t believe I didn’t get a better look at him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her tone was fierce and brave, but he noticed the slight trembling of her hands. He didn’t blame her for being scared; there was no acceptable reason for a man to loiter around a woman’s car at ten o’clock at night. Even if she had imagined the guy, he figured she was entitled after such a long day. “I’ll walk you to your car.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m fine.” She started toward her car with a firm stride, but didn’t protest when he caught up to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A small white card with her name printed on the outside was stuck beneath the wiper blade on the driver’s side. Obviously, her mystery man wasn’t her imagination after all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gasped in shock and stopped short, staring at the evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t touch anything,” he ordered. “We need to call the police, see if we can get some fingerprints off this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t bother.” Her tone was matter of fact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean, don’t bother?” What sort of CSI expert was she? “Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because I’ve gotten several others just like it, and he hasn’t left any prints yet.”")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89be6302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459216273_ch01.vue
// module id = 78
// module chunks = 0